import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { FaTrophy } from 'react-icons/fa'

import { SectionHeader, Skeleton } from '../ui'
import HomeSection from './HomeSection'
import GiveawayCard from '../marketing/GiveawayCard'
import { get_giveaways } from '../../store/reducers/giveawayReducer'

// GiveawayHomeSection — shows up to 3 active giveaways. Hides when none.
const GiveawayHomeSection = () => {
    const dispatch = useDispatch()
    const { t } = useTranslation()
    const { giveaways, loader } = useSelector(s => s.giveaway)

    // Always refetch with an explicit `active` filter on mount — the slice is
    // shared with /cekilisler and could otherwise hold a filtered/stale list.
    useEffect(() => {
        dispatch(get_giveaways({ page: 1, limit: 6, status: 'active' }))
    }, [dispatch])

    const activeList = useMemo(
        () => (giveaways || []).filter(g => g.status === 'active').slice(0, 3),
        [giveaways],
    )

    if (loader && activeList.length === 0) {
        return (
            <HomeSection>
                <div className='grid grid-cols-3 md-lg:grid-cols-2 sm:grid-cols-1 gap-4'>
                    {[0, 1, 2].map(i => (
                        <Skeleton key={i} radius='card' className='w-full aspect-[4/3]' />
                    ))}
                </div>
            </HomeSection>
        )
    }
    if (activeList.length === 0) return null

    return (
        <HomeSection>
            <SectionHeader
                eyebrow={{ icon: <FaTrophy />, label: t('home.giveaways.eyebrow'), tone: 'brand' }}
                title={t('home.giveaways.title')}
                subtitle={t('home.giveaways.subtitle')}
                action={{ to: '/cekilisler', label: t('home.giveaways.cta') }}
            />
            <div className='grid grid-cols-3 md-lg:grid-cols-2 sm:grid-cols-1 gap-4'>
                {activeList.map(g => (
                    <GiveawayCard key={g._id || g.slug} giveaway={g} variant='home' />
                ))}
            </div>
        </HomeSection>
    )
}

export default GiveawayHomeSection
